const flatStandardDescriptionTrigger = () => {
  if (!document.querySelector('body').classList.contains('single-mieszkanie')) return;

  const standardTrigger = document.querySelector('.took .standard-description-trigger');
  const standardDescription = document.querySelector('.took .standard-description');

  if (!standardTrigger || !standardDescription) return;

  standardTrigger.addEventListener('click', function() {
    standardDescription.classList.toggle('active');
  });
}

$(document).ready(flatStandardDescriptionTrigger);